function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"])
    return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r))
    return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
    var o, i = p[t], d = G.p, l = i[2];
    r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
} if (o || r > 1)
    return a; throw y = !0, n; } return function (o, p, l) { if (f > 1)
    throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
    i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
    try {
        if (f = 2, i) {
            if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u)))
                    throw TypeError("iterator result is not an object");
                if (!t.done)
                    return t;
                u = t.value, c < 2 && (c = 0);
            }
            else
                1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
            i = e;
        }
        else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a)
            break;
    }
    catch (t) {
        i = e, c = 1, u = t;
    }
    finally {
        f = 1;
    }
} return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() { } function GeneratorFunction() { } function GeneratorFunctionPrototype() { } t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try {
    i({}, "", {});
}
catch (e) {
    i = 0;
} _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try {
    var i = n[a](c), u = i.value;
}
catch (n) {
    return void e(n);
} i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) {
    if ("string" == typeof r)
        return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
} }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++)
    n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) {
    var e, n, i, u, a = [], f = !0, o = !1;
    try {
        if (i = (t = t.call(r)).next, 0 === l) {
            if (Object(t) !== t)
                return;
            f = !1;
        }
        else
            for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0)
                ;
    }
    catch (r) {
        o = !0, n = r;
    }
    finally {
        try {
            if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
                return;
        }
        finally {
            if (o)
                throw n;
        }
    }
    return a;
} }
function _arrayWithHoles(r) { if (Array.isArray(r))
    return r; }
import React, { useState, useEffect } from 'react';
import { Box, Typography, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, IconButton, Alert, Stack, CircularProgress, Checkbox, Chip } from '@mui/material';
import { Add as AddIcon, DeleteOutlined as DeleteIcon, FilterListOutlined as FilterIcon, ListAltOutlined as EditIcon } from '@mui/icons-material';
import { ConfirmationDialog } from '../components/ConfirmationDialog';
import UserGroupModal from '../components/UserGroupModal';
import UserGroupDrawer from '../components/UserGroupDrawer';
import { UserAPI } from '../apis/UserAPI';
import { isAuthorized } from '../utils/utilities';
import authenticatedRoute from '../views/AuthenticatedRoute';
import { constants } from '../constants';
import { useThemeDetails } from '../components/ThemeDetailsContext';
var UserGroups = function UserGroups() {
    var _userGroupToDelete$na;
    var _useThemeDetails = useThemeDetails(), stateImages = _useThemeDetails.stateImages;
    var _useState = useState([]), _useState2 = _slicedToArray(_useState, 2), userGroups = _useState2[0], setUserGroups = _useState2[1];
    var _useState3 = useState([]), _useState4 = _slicedToArray(_useState3, 2), applications = _useState4[0], setApplications = _useState4[1];
    var _useState5 = useState([]), _useState6 = _slicedToArray(_useState5, 2), roles = _useState6[0], setRoles = _useState6[1];
    var _useState7 = useState(''), _useState8 = _slicedToArray(_useState7, 2), selectedApplication = _useState8[0], setSelectedApplication = _useState8[1];
    var _useState9 = useState(true), _useState0 = _slicedToArray(_useState9, 2), dataLoading = _useState0[0], setDataLoading = _useState0[1];
    var _useState1 = useState(null), _useState10 = _slicedToArray(_useState1, 2), error = _useState10[0], setError = _useState10[1];
    var _useState11 = useState(''), _useState12 = _slicedToArray(_useState11, 2), successMessage = _useState12[0], setSuccessMessage = _useState12[1];
    var _useState13 = useState(false), _useState14 = _slicedToArray(_useState13, 2), loading = _useState14[0], setLoading = _useState14[1];
    var _useState15 = useState([]), _useState16 = _slicedToArray(_useState15, 2), selectedGroups = _useState16[0], setSelectedGroups = _useState16[1];
    var _useState17 = useState(false), _useState18 = _slicedToArray(_useState17, 2), bulkDeleteDialogOpen = _useState18[0], setBulkDeleteDialogOpen = _useState18[1];
    var _useState19 = useState(false), _useState20 = _slicedToArray(_useState19, 2), bulkDeleteLoading = _useState20[0], setBulkDeleteLoading = _useState20[1];
    // Modal and drawer state
    var _useState21 = useState(false), _useState22 = _slicedToArray(_useState21, 2), userGroupModalOpen = _useState22[0], setUserGroupModalOpen = _useState22[1];
    var _useState23 = useState(null), _useState24 = _slicedToArray(_useState23, 2), selectedUserGroup = _useState24[0], setSelectedUserGroup = _useState24[1];
    var _useState25 = useState(false), _useState26 = _slicedToArray(_useState25, 2), deleteDialogOpen = _useState26[0], setDeleteDialogOpen = _useState26[1];
    var _useState27 = useState(null), _useState28 = _slicedToArray(_useState27, 2), userGroupToDelete = _useState28[0], setUserGroupToDelete = _useState28[1];
    var _useState29 = useState(false), _useState30 = _slicedToArray(_useState29, 2), drawerOpen = _useState30[0], setDrawerOpen = _useState30[1];
    var _useState31 = useState(null), _useState32 = _slicedToArray(_useState31, 2), drawerGroup = _useState32[0], setDrawerGroup = _useState32[1];
    // Load data on component mount
    useEffect(function () {
        loadInitialData();
    }, []);
    var loadInitialData = /*#__PURE__*/ function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee() {
            var _yield$Promise$all, _yield$Promise$all2, apps, userGroupsResponse, rolesResponse, rolesData, transformedRoles, transformedGroups, appList, _t;
            return _regenerator().w(function (_context) {
                while (1)
                    switch (_context.p = _context.n) {
                        case 0:
                            setDataLoading(true);
                            setError(null);
                            _context.p = 1;
                            _context.n = 2;
                            return Promise.all([UserAPI.getAllApplications(), UserAPI.getUserGroups(), UserAPI.getRoles()]);
                        case 2:
                            _yield$Promise$all = _context.v;
                            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 3);
                            apps = _yield$Promise$all2[0];
                            userGroupsResponse = _yield$Promise$all2[1];
                            rolesResponse = _yield$Promise$all2[2];
                            setApplications(apps.resource || apps);
                            // Debug: Log roles response
                            console.log('UserGroups - Roles response:', rolesResponse);
                            console.log('UserGroups - Roles resource:', rolesResponse.resource);
                            // Transform roles to ensure consistent format
                            rolesData = rolesResponse.resource || rolesResponse || [];
                            transformedRoles = Array.isArray(rolesData) ? rolesData.map(function (role) {
                                return {
                                    id: role.role_id || role.id,
                                    name: role.role_name || role.name || 'Unnamed Role'
                                };
                            }) : [];
                            console.log('UserGroups - Transformed roles:', transformedRoles);
                            setRoles(transformedRoles);
                            // Transform user groups data
                            transformedGroups = userGroupsResponse.resource.map(function (group) {
                                var _group$metadata;
                                return {
                                    id: group.id,
                                    name: group.name || 'Unnamed Group',
                                    organization_id: group.organization_id,
                                    principal_type: group.principal_type,
                                    memberCount: group.memberCount || 0,
                                    dateAdded: (_group$metadata = group.metadata) !== null && _group$metadata !== void 0 && _group$metadata.createdDate ? new Date(group.metadata.createdDate).toLocaleDateString('en-US', {
                                        month: 'short',
                                        day: 'numeric',
                                        year: 'numeric'
                                    }) : 'Unknown',
                                    details: group.details
                                };
                            });
                            setUserGroups(transformedGroups);
                            // Set default application filter to first application if available
                            appList = apps.resource || apps;
                            if (Array.isArray(appList) && appList.length > 0) {
                                setSelectedApplication(appList[0].name);
                            }
                            _context.n = 4;
                            break;
                        case 3:
                            _context.p = 3;
                            _t = _context.v;
                            console.error('Failed to load data:', _t);
                            setError(constants.user_groups_error_load_data);
                            setUserGroups([]);
                        case 4:
                            _context.p = 4;
                            setDataLoading(false);
                            return _context.f(4);
                        case 5:
                            return _context.a(2);
                    }
            }, _callee, null, [[1, 3, 4, 5]]);
        }));
        return function loadInitialData() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleAddUserGroup = function handleAddUserGroup() {
        if (!selectedApplication) {
            setError(constants.user_groups_select_app_before_create);
            return;
        }
        setSelectedUserGroup(null);
        setUserGroupModalOpen(true);
    };
    var handleOpenGroupDrawer = function handleOpenGroupDrawer(group) {
        setDrawerGroup(group);
        setDrawerOpen(true);
    };
    var handleEditUserGroup = function handleEditUserGroup(group) {
        setSelectedUserGroup(group);
        setUserGroupModalOpen(true);
    };
    var handleDeleteUserGroup = function handleDeleteUserGroup(group) {
        setUserGroupToDelete(group);
        setDeleteDialogOpen(true);
    };
    var handleSaveUserGroup = /*#__PURE__*/ function () {
        var _ref2 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee2(groupData) {
            var _groupData$roleIds, _groupData$roleIds2, selectedApp, createdGroup, _t2;
            return _regenerator().w(function (_context2) {
                while (1)
                    switch (_context2.p = _context2.n) {
                        case 0:
                            setLoading(true);
                            setError(null);
                            _context2.p = 1;
                            if (!selectedUserGroup) {
                                _context2.n = 4;
                                break;
                            }
                            _context2.n = 2;
                            return UserAPI.updateUserGroup(selectedUserGroup.id.toString(), {
                                name: groupData.name,
                                organization_id: selectedUserGroup.organization_id,
                                principal_type: selectedUserGroup.principal_type,
                                details: {
                                    description: groupData.description || '',
                                    roles: ((_groupData$roleIds = groupData.roleIds) === null || _groupData$roleIds === void 0 ? void 0 : _groupData$roleIds.map(String)) || []
                                }
                            });
                        case 2:
                            if (!(groupData.roleIds && groupData.roleIds.length > 0)) {
                                _context2.n = 3;
                                break;
                            }
                            _context2.n = 3;
                            return UserAPI.assignRolesToPrincipal(groupData.roleIds, selectedUserGroup.id, 2 // principal_type 2 = Group
                            );
                        case 3:
                            setSuccessMessage(constants.user_groups_update_success || 'User group updated successfully');
                            _context2.n = 8;
                            break;
                        case 4:
                            // Create new user group
                            selectedApp = applications.find(function (app) {
                                return app.name === selectedApplication;
                            });
                            if (selectedApp) {
                                _context2.n = 5;
                                break;
                            }
                            throw new Error('No application selected');
                        case 5:
                            _context2.n = 6;
                            return UserAPI.createUserGroup({
                                name: groupData.name,
                                organization_id: selectedApp.organization_id,
                                principal_type: 2,
                                details: {
                                    description: groupData.description || '',
                                    roles: ((_groupData$roleIds2 = groupData.roleIds) === null || _groupData$roleIds2 === void 0 ? void 0 : _groupData$roleIds2.map(String)) || []
                                }
                            });
                        case 6:
                            createdGroup = _context2.v;
                            if (!(groupData.roleIds && groupData.roleIds.length > 0 && createdGroup !== null && createdGroup !== void 0 && createdGroup.id)) {
                                _context2.n = 7;
                                break;
                            }
                            _context2.n = 7;
                            return UserAPI.assignRolesToPrincipal(groupData.roleIds, createdGroup.id, 2 // principal_type 2 = Group
                            );
                        case 7:
                            setSuccessMessage(constants.user_groups_add_success);
                        case 8:
                            _context2.n = 9;
                            return loadInitialData();
                        case 9:
                            setUserGroupModalOpen(false);
                            setSelectedUserGroup(null);
                            _context2.n = 11;
                            break;
                        case 10:
                            _context2.p = 10;
                            _t2 = _context2.v;
                            console.error('Failed to save user group:', _t2);
                            setError(_t2 instanceof Error ? _t2.message : constants.user_groups_error_save_group);
                        case 11:
                            _context2.p = 11;
                            setLoading(false);
                            return _context2.f(11);
                        case 12:
                            return _context2.a(2);
                    }
            }, _callee2, null, [[1, 10, 11, 12]]);
        }));
        return function handleSaveUserGroup(_x) {
            return _ref2.apply(this, arguments);
        };
    }();
    var confirmDeleteUserGroup = /*#__PURE__*/ function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee3() {
            var _t3;
            return _regenerator().w(function (_context3) {
                while (1)
                    switch (_context3.p = _context3.n) {
                        case 0:
                            if (userGroupToDelete) {
                                _context3.n = 1;
                                break;
                            }
                            return _context3.a(2);
                        case 1:
                            setLoading(true);
                            setError(null);
                            _context3.p = 2;
                            _context3.n = 3;
                            return UserAPI.deleteUserGroup(userGroupToDelete.id.toString());
                        case 3:
                            setSuccessMessage(constants.user_groups_delete_success);
                            // Close dialog and drawer first, then reload data
                            setDeleteDialogOpen(false);
                            setUserGroupToDelete(null);
                            setDrawerOpen(false);
                            setDrawerGroup(null);
                            _context3.n = 4;
                            return loadInitialData();
                        case 4:
                            _context3.n = 6;
                            break;
                        case 5:
                            _context3.p = 5;
                            _t3 = _context3.v;
                            console.error('Failed to delete user group:', _t3);
                            // Close dialog on error but do NOT reload data - row should stay
                            setDeleteDialogOpen(false);
                            setUserGroupToDelete(null);
                            setError(_t3 instanceof Error ? _t3.message : constants.user_groups_error_delete_group);
                        case 6:
                            _context3.p = 6;
                            setLoading(false);
                            return _context3.f(6);
                        case 7:
                            return _context3.a(2);
                    }
            }, _callee3, null, [[2, 5, 6, 7]]);
        }));
        return function confirmDeleteUserGroup() {
            return _ref3.apply(this, arguments);
        };
    }();
    var handleSelectAll = function handleSelectAll(event) {
        if (event.target.checked) {
            var allGroupIds = filteredGroups.map(function (group) {
                return group.id;
            });
            setSelectedGroups(allGroupIds);
        }
        else {
            setSelectedGroups([]);
        }
    };
    var handleSelectGroup = function handleSelectGroup(groupId) {
        setSelectedGroups(function (prev) {
            return prev.includes(groupId) ? prev.filter(function (id) {
                return id !== groupId;
            }) : [].concat(_toConsumableArray(prev), [groupId]);
        });
    };
    // Filter user groups based on selected application
    var filteredGroups = userGroups.filter(function (group) {
        if (!selectedApplication)
            return true;
        // Find the application by name to get its organization_id
        var selectedApp = applications.find(function (app) {
            return app.name === selectedApplication;
        });
        if (!selectedApp)
            return false;
        // Check if the group's organization_id matches
        return String(group.organization_id) === String(selectedApp.organization_id);
    });
    // Bulk delete handler
    var handleBulkDelete = function handleBulkDelete() {
        setBulkDeleteDialogOpen(true);
    };
    var confirmBulkDeleteUserGroups = /*#__PURE__*/ function () {
        var _ref4 = _asyncToGenerator(/*#__PURE__*/ _regenerator().m(function _callee4() {
            var _t4;
            return _regenerator().w(function (_context4) {
                while (1)
                    switch (_context4.p = _context4.n) {
                        case 0:
                            if (!(selectedGroups.length === 0)) {
                                _context4.n = 1;
                                break;
                            }
                            return _context4.a(2);
                        case 1:
                            setBulkDeleteLoading(true);
                            setError(null);
                            _context4.p = 2;
                            _context4.n = 3;
                            return Promise.all(selectedGroups.map(function (groupId) {
                                return UserAPI.deleteUserGroup(groupId.toString());
                            }));
                        case 3:
                            setSuccessMessage(constants.user_groups_delete_success || 'Groups deleted successfully');
                            setSelectedGroups([]);
                            _context4.n = 4;
                            return loadInitialData();
                        case 4:
                            setBulkDeleteDialogOpen(false);
                            _context4.n = 6;
                            break;
                        case 5:
                            _context4.p = 5;
                            _t4 = _context4.v;
                            console.error('Failed to bulk delete user groups:', _t4);
                            setError(_t4 instanceof Error ? _t4.message : constants.user_groups_error_delete_group);
                        case 6:
                            _context4.p = 6;
                            setBulkDeleteLoading(false);
                            return _context4.f(6);
                        case 7:
                            return _context4.a(2);
                    }
            }, _callee4, null, [[2, 5, 6, 7]]);
        }));
        return function confirmBulkDeleteUserGroups() {
            return _ref4.apply(this, arguments);
        };
    }();
    // Check view permission
    if (!isAuthorized('RBAC:ViewUserGroup')) {
        return /*#__PURE__*/ React.createElement(Box, {
            sx: {
                p: 3,
                bgcolor: '#f8f8f8'
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                textAlign: 'center',
                py: 8
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "h6",
            color: "#666",
            gutterBottom: true
        }, constants.user_groups_access_denied_title), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body1",
            color: "#888"
        }, constants.user_groups_access_denied_desc)));
    }
    return /*#__PURE__*/ React.createElement(Box, {
        sx: {
            p: 3,
            bgcolor: '#f8f8f8',
            minHeight: '100vh'
        }
    }, /*#__PURE__*/ React.createElement(Paper, {
        sx: {
            p: 3,
            borderRadius: 2,
            boxShadow: 'none'
        }
    }, /*#__PURE__*/ React.createElement(Box, {
        sx: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#595959"
    }, constants.user_groups_header_description), /*#__PURE__*/ React.createElement(Box, null, !dataLoading && !error && selectedGroups.length > 0 && isAuthorized('RBAC:DeleteUserGroup') && /*#__PURE__*/ React.createElement(Button, {
        variant: "outlined",
        onClick: handleBulkDelete,
        disabled: bulkDeleteLoading,
        sx: {
            color: '#DA291C',
            border: '1px solid #DA291C',
            backgroundColor: 'transparent',
            boxShadow: 'none',
            mr: 1
        }
    }, /*#__PURE__*/ React.createElement(DeleteIcon, null)), /*#__PURE__*/ React.createElement(Button, {
        variant: "contained",
        startIcon: /*#__PURE__*/ React.createElement(AddIcon, null),
        onClick: handleAddUserGroup,
        disabled: !isAuthorized('RBAC:CreateUserGroup'),
        sx: {
            bgcolor: '#26890d',
            textTransform: 'none',
            boxShadow: 'none',
            fontWeight: 600,
            '&:hover': {
                bgcolor: '#1f6f0a'
            }
        }
    }, "Group"))), dataLoading && /*#__PURE__*/ React.createElement(Box, {
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, stateImages !== null && stateImages !== void 0 && stateImages.Loading ? /*#__PURE__*/ React.createElement(Box, {
        component: "img",
        src: stateImages.Loading,
        alt: "Loading",
        sx: {
            width: 128,
            height: 128
        }
    }) : /*#__PURE__*/ React.createElement(CircularProgress, null), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            mt: 2
        }
    }, constants.user_groups_loading)), error && /*#__PURE__*/ React.createElement(Alert, {
        severity: "error",
        sx: {
            mb: 3
        }
    }, error), successMessage && /*#__PURE__*/ React.createElement(Alert, {
        severity: "success",
        sx: {
            mb: 3
        },
        onClose: function onClose() {
            return setSuccessMessage('');
        }
    }, successMessage), !dataLoading && /*#__PURE__*/ React.createElement(TableContainer, null, /*#__PURE__*/ React.createElement(Table, null, /*#__PURE__*/ React.createElement(TableHead, null, /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 1
        }
    }, /*#__PURE__*/ React.createElement(Stack, {
        direction: "row",
        alignItems: "center",
        gap: 1
    }, /*#__PURE__*/ React.createElement(Checkbox, {
        size: "small",
        checked: filteredGroups.length > 0 && selectedGroups.length === filteredGroups.length,
        indeterminate: selectedGroups.length > 0 && selectedGroups.length < filteredGroups.length,
        onChange: handleSelectAll,
        sx: {
            color: '#d9d9d9',
            '&.Mui-checked': {
                color: '#26890d'
            }
        }
    }), /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            fontSize: '14px'
        }
    }, "Name"), /*#__PURE__*/ React.createElement(FilterIcon, {
        sx: {
            fontSize: 18,
            color: '#26890d'
        }
    }))), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            fontSize: '14px'
        }
    }, "# of people assigned")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            fontSize: '14px'
        }
    }, "Role")), /*#__PURE__*/ React.createElement(TableCell, {
        sx: {
            borderBottom: '1px solid #ebebeb',
            py: 1
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body2",
        sx: {
            fontWeight: 600,
            fontSize: '14px'
        }
    }, constants.common_table_header_action)))), /*#__PURE__*/ React.createElement(TableBody, null, filteredGroups.length === 0 ? /*#__PURE__*/ React.createElement(TableRow, null, /*#__PURE__*/ React.createElement(TableCell, {
        colSpan: 4,
        sx: {
            textAlign: 'center',
            py: 4
        }
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "body1",
        color: "#888"
    }, constants.user_groups_no_groups_found))) : filteredGroups.map(function (group) {
        var _group$details;
        return /*#__PURE__*/ React.createElement(TableRow, {
            key: group.id
        }, /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: '1px solid #ebebeb',
                py: 1
            }
        }, /*#__PURE__*/ React.createElement(Stack, {
            direction: "row",
            alignItems: "center",
            gap: 1
        }, /*#__PURE__*/ React.createElement(Checkbox, {
            size: "small",
            checked: selectedGroups.includes(group.id),
            onChange: function onChange() {
                return handleSelectGroup(group.id);
            },
            sx: {
                color: '#d9d9d9',
                '&.Mui-checked': {
                    color: '#26890d'
                }
            }
        }), /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                fontWeight: 600,
                fontSize: '14px',
                color: '#26890d',
                textDecoration: 'underline',
                cursor: 'pointer',
                '&:hover': {
                    textDecoration: 'underline'
                }
            },
            onClick: function onClick() {
                return handleOpenGroupDrawer(group);
            }
        }, group.name))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: '1px solid #ebebeb',
                py: 1
            }
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                fontSize: '14px'
            }
        }, group.memberCount)), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: '1px solid #ebebeb',
                py: 1
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                flexWrap: 'wrap',
                gap: 0.5
            }
        }, (_group$details = group.details) !== null && _group$details !== void 0 && _group$details.roles && Array.isArray(group.details.roles) && group.details.roles.length > 0 ? group.details.roles.map(function (roleId) {
            var role = roles.find(function (r) {
                return String(r.id) === String(roleId);
            });
            return role ? /*#__PURE__*/ React.createElement(Chip, {
                key: roleId,
                label: role.name,
                size: "small",
                sx: {
                    backgroundColor: '#f3f8eb',
                    color: '#1a5d09',
                    fontFamily: 'Open Sans',
                    fontSize: 12,
                    fontWeight: 600,
                    height: 20
                }
            }) : null;
        }) : /*#__PURE__*/ React.createElement(Typography, {
            variant: "body2",
            sx: {
                fontSize: '14px',
                color: '#888'
            }
        }, "-"))), /*#__PURE__*/ React.createElement(TableCell, {
            sx: {
                borderBottom: '1px solid #ebebeb',
                py: 1
            }
        }, /*#__PURE__*/ React.createElement(Box, {
            sx: {
                display: 'flex',
                gap: 1
            }
        }, isAuthorized('RBAC:UpdateUserGroup') && /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleEditUserGroup(group);
            },
            sx: {
                color: '#26890d',
                '&:hover': {
                    bgcolor: 'rgba(38, 137, 13, 0.04)'
                }
            },
            size: "small"
        }, /*#__PURE__*/ React.createElement(EditIcon, {
            fontSize: "small"
        })), isAuthorized('RBAC:DeleteUserGroup') && /*#__PURE__*/ React.createElement(IconButton, {
            onClick: function onClick() {
                return handleDeleteUserGroup(group);
            },
            sx: {
                color: '#da291c',
                '&:hover': {
                    bgcolor: 'rgba(218, 41, 28, 0.04)'
                }
            },
            size: "small"
        }, /*#__PURE__*/ React.createElement(DeleteIcon, {
            fontSize: "small"
        })))));
    }))))), /*#__PURE__*/ React.createElement(UserGroupModal, {
        open: userGroupModalOpen,
        onClose: function onClose() {
            setUserGroupModalOpen(false);
            setSelectedUserGroup(null);
        },
        onSave: handleSaveUserGroup,
        group: selectedUserGroup,
        loading: loading,
        applications: applications,
        roles: roles
    }), /*#__PURE__*/ React.createElement(UserGroupDrawer, {
        open: drawerOpen,
        onClose: function onClose() {
            setDrawerOpen(false);
            setDrawerGroup(null);
        },
        group: drawerGroup,
        onDelete: handleDeleteUserGroup,
        onMembersUpdated: loadInitialData
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: deleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setDeleteDialogOpen(false);
            setUserGroupToDelete(null);
        },
        submitFunction: confirmDeleteUserGroup,
        bodyText: constants.user_groups_delete_confirm_body((_userGroupToDelete$na = userGroupToDelete === null || userGroupToDelete === void 0 ? void 0 : userGroupToDelete.name) !== null && _userGroupToDelete$na !== void 0 ? _userGroupToDelete$na : ''),
        submitButtonText: constants["delete"],
        loading: loading
    }), /*#__PURE__*/ React.createElement(ConfirmationDialog, {
        isOpen: bulkDeleteDialogOpen,
        setIsOpen: function setIsOpen() {
            setBulkDeleteDialogOpen(false);
        },
        submitFunction: confirmBulkDeleteUserGroups,
        bodyText: selectedGroups.length === 0 ? 'No groups selected.' : "Are you sure you want to delete ".concat(selectedGroups.length, " selected group(s)? This action cannot be undone."),
        submitButtonText: constants["delete"],
        loading: bulkDeleteLoading
    }));
};
export default authenticatedRoute(UserGroups);
